import { trackEvent } from '@/entities/sogu';
import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { excursionMapFilterDataToSogu } from '@/entities/filter/store/utils/excursion/ExcursionMapFilterDataToSogu.ts';
import type { ContextGeoSubject } from '@/shared/types/geography.ts';
import { useExcursionSoguStore } from '@/features/sogu/excursion';
import { removeNullableProperties } from '@/shared/lib/removeNullableProperties.ts';

export function useExcursionSortingClickTracker() {
  const filtersStore = useExcursionFiltersStore();
  const soguStore = useExcursionSoguStore();

  const trackSortingClick = (defaultSoguFields: ContextGeoSubject) => {
    trackEvent('listing:sorting.click', {
      ...defaultSoguFields.soguStamp,
      ...removeNullableProperties(excursionMapFilterDataToSogu(filtersStore.state)),
      tag_id: soguStore.rubricId,
      filter_window_type: 'manual_listing_open_popup',
      total_experiences: soguStore.totalExperiences,
      filtered_experiences: soguStore.filteredExperiences,
    });
  };

  return {
    trackSortingClick,
  };
}
